angular.module('impactx').provider('panelService', PanelService);

function PanelService() {
    var self = this;
    self.tenderPanelColors = new Map();
    self.lotPanelColors = new Map();
    self.catalogPanelColors = new Map();
    self.productPanelColors = new Map();
    self.supplierPanelColors = new Map();

    self.getTenderPanelColor = function (value) {
        return self.tenderPanelColors.get(value);
    };

    self.getLotPanelColor = function (value) {
        return self.lotPanelColors.get(value);
    };

    self.getCatalogPanelColor = function (value) {
        return self.catalogPanelColors.get(value);
    };

    self.getProductPanelColor = function (value) {
        return self.productPanelColors.get(value);
    };

    self.getSupplierPanelColor = function (value) {
        return self.supplierPanelColors.get(value);
    };

    self.initializePanelColors = function (panelType, panelColorMap) {
        switch (panelType) {
            case 'tender':
                self.tenderPanelColors = panelColorMap;
                break;
            case 'lot':
                self.lotPanelColors = panelColorMap;
                break;
            case 'catalog':
                self.catalogPanelColors = panelColorMap;
                break;
            case 'product':
                self.productPanelColors = panelColorMap;
                break;
            case 'supplier':
                self.supplierPanelColors = panelColorMap;
                break;
            default:
                console.log("PanelService: Panel Type " + panelType + "not supported");
        }

    };

    self.$get = function () {
        return {
            initializePanelColors: self.initializePanelColors,
            getTenderPanelColor: self.getTenderPanelColor,
            getLotPanelColor: self.getLotPanelColor,
            getCatalogPanelColor: self.getCatalogPanelColor,
            getProductPanelColor: self.getProductPanelColor,
            getSupplierPanelColor: self.getSupplierPanelColor,
        };
    };
}


